import { MLS, MLSID, noop } from '@aloft/toolkit-shared';
import {
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Typography,
} from '@aloft/toolkit-sui';

import { ElementRef, forwardRef } from 'react';

const MoreMenuButton = forwardRef<ElementRef<'button'>>((props, ref) => {
  return (
    <IconButton
      ref={ref}
      size="xs"
      icon="more"
      variant="tertiary"
      iconColor="surfaceAccent2"
      onClick={noop}
      ariaLabel="Remove"
      {...props}
    />
  );
});

type Props = {
  mlsID: MLSID;
  onRemove: (mlsID: MLSID) => void;
};

export function MLSListItem(props: Props) {
  const { mlsID, onRemove } = props;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      backgroundColor="surface6"
      padding="4px 8px"
      borderRadius="4px"
    >
      <span style={{ marginRight: '48px' }}>
        <Typography>{MLS[mlsID].longName}</Typography>
      </span>
      <Flex alignItems="center" gap="8px">
        <Menu>
          <MenuButton as={MoreMenuButton} />
          <MenuList>
            <MenuItem onClick={() => onRemove(mlsID)}>
              <Typography>Remove</Typography>
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}
